module.exports = __webpack_public_path__ + "Assets/9b0d5970-235c-47a8-b94d-a7fe9dea7585.ttf";